import { render } from "./Headers.vue?vue&type=template&id=0d4be6ce"
import script from "./Headers.vue?vue&type=script&lang=js"
export * from "./Headers.vue?vue&type=script&lang=js"

import "./Headers.vue?vue&type=style&index=0&id=0d4be6ce&lang=css"

import exportComponent from "/home/vshemyatin/phonebook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__